import type { ProductType } from "@/type/ProductType";

/** Stock level from article.quantité_article — mapped to product.quantity in Productlist */
export function getStockQuantity(product: Pick<ProductType, "quantity"> | null | undefined): number {
  const q = Number(product?.quantity);
  if (!Number.isFinite(q)) return 0;
  return Math.max(0, Math.floor(q));
}

type StockProduct = Pick<ProductType, "quantity"> &
  Partial<Pick<ProductType, "out_of_stock" | "stock_mode">>;

export function isOutOfStock(product: StockProduct | null | undefined): boolean {
  const mode = String(product?.stock_mode || "auto").toLowerCase();

  // Manual mode: ignore quantity and rely only on article.out_of_stock flag (1 => rupture).
  if (mode === "manual") {
    return Number(product?.out_of_stock || 0) === 1;
  }

  // Auto mode (default): existing behavior based on quantity.
  return getStockQuantity(product) <= 0;
}
